import { SelectionChangedEvent } from "ag-grid-community";
import { MovementPatternDtlEntity } from "domain/entity/MovementPattern/MovementPatternDtlEntity";
import _ from "lodash";
import { MovementPatternConstant } from "presentation/constant/MovementPattern/MovementPatternConstant";
import { INITIAL_MOVEMENT_PATTERN_DTL_COL_DEF } from "presentation/constant/MovementPattern/MovementPatternDtlColumnDefinition";
import { useMovementPatternVM } from "presentation/hook/MovementPattern/useMovementPatternVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { MovementPatternModel } from "presentation/model/MovementPattern/MovementPatternModel";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import RightClickMenuWithMoveAfter from "presentation/view/components/NbisRightClickMenu/RightClickMenuWithMoveAfter";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { createRef, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import MovementPatternDtlEditPanel from "../RightPanel/MovementPatternDtlEditPanel";
const MovementPatternDtlTablePanel = ({ movementPatternState }: { movementPatternState: MovementPatternModel }) => {
    const gridRef: any = useRef(null);
    const { selectedDtlRows, isShowDtlAddPanel, isShowDtlEditPanel, isEdit, isAdd } = movementPatternState;
    const movementPatternVM = useMovementPatternVM();
    const messageBarVM = useMessageBarVM();
    const [anainfoState] = useANAInfoTracked();
    const { allowUpdate, allowCreate, allowDelete } = anainfoState;
    const rightClickRef: any = createRef();
    // for right click menu with move after begin
    const [showMoveCursor, setShowMoveCursor] = useState<boolean>(false);
    const [allRows, setAllRows] = useState<MovementPatternDtlEntity[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [initialAllRows, setInitialAllRows] = useState<boolean>(true);
    // const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);

    const getAllRows = useCallback(() => {
        return allRows;
    }, [allRows]);

    const getSelectedRows = useCallback(() => {
        return movementPatternState.selectedDtlRows;
    }, [movementPatternState.selectedDtlRows]);

    // const getShowMoveCursor = useCallback(() => {
    //     return showMoveCursor;
    // }, [showMoveCursor]);
    //for right click menu with move after end

    // useEffect(() => {
    //     //const columnDefs = (INITIAL_MOVEMENT_PATTERN_COL_DEF?.slice());

    //     // if (!movementPatternState.selectedDtlRows || movementPatternState.selectedDtlRows.length <= 0) {
    //     //gridRef.current?.gridRef.current.api?.setColumnDefs(columnDefs);
    //     if (!onTableSelectionClicked) {
    //         gridRef.current?.gridRef.current.api?.deselectAll();
    //     }
    //     // }
    //     changeCursor("movement-pattern-dtl-table", getShowMoveCursor());
    // });

    // useEffect(() => {
    //     if (!onTableSelectionClicked) return;
    //     gridRef?.current?.gridRef.current.api?.deselectAll();
    //     changeCursor("movement-pattern-dtl-table", getShowMoveCursor());
    // }, [getShowMoveCursor, onTableSelectionClicked]);

    useEffect(() => {
        const handleRightClickMenu = (event: any) => {
            if (_.isEmpty(movementPatternState.selectedDtlRows) || !allowUpdate) {
                return;
            }
            event.preventDefault();
            rightClickRef.current.show(event);
        };
        document.getElementById('myDiv')?.addEventListener("contextmenu", handleRightClickMenu);

        return () => {
            document.getElementById('myDiv')?.removeEventListener("contextmenu", handleRightClickMenu);
        };
    }, [messageBarVM, rightClickRef, allowUpdate, movementPatternState.selectedDtlRows]);

    // for right click menu with move after begin
    const onRefreshRow = useCallback((newAllRows: any[]) => {
        setAllRows(newAllRows);
        movementPatternVM.updateSelectedDtlRows([]);
        setShowMoveCursor(true);
    }, [movementPatternVM]);

    const onMoveCancel = useCallback(() => {
        setInitialAllRows(true);
        setAllRows(movementPatternState.tempDtlRows);
        movementPatternVM.updateSelectedDtlRows([]);
        setShowMoveCursor(false);
    }, [movementPatternState.tempDtlRows, movementPatternVM]);

    const onSaveMove = useCallback(async (newAllRows: any[]) => {
        if (_.isEmpty(newAllRows)) return;

        setIsLoading(true);
        movementPatternVM.showMovementPatternDtlListAfterSort(newAllRows).then((res) => {
            movementPatternVM.updateSelectedDtlRows([]);
            setShowMoveCursor(false);
        });
        setIsLoading(false);
    }, [movementPatternVM]);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        // setOnTableSelectionClicked(true);
        movementPatternVM.updateSelectedDtlRows(selectedRows);
    }, [movementPatternVM])


    const handleRowDoubleClick = useCallback((entity: MovementPatternDtlEntity) => {
        if (!isEdit && !isAdd) return;
        movementPatternVM.onDtlRowDoubleClick(entity);
    }, [movementPatternVM, isAdd, isEdit])

    const handleAddClick = useCallback(() => {

        movementPatternVM.onDtlAddRowClick();
    }, [movementPatternVM])

    const handDelete = useCallback(() => {
        if (selectedDtlRows.length === 0) {
            messageBarVM.showError("Please select a record.");
        }
        movementPatternVM.onDtlDtlDeleteClick(selectedDtlRows);
        setInitialAllRows(true);
    }, [movementPatternVM, messageBarVM, selectedDtlRows]);

    const memoBtns = useMemo(() => {

        const hdrBtns = [];
        allowDelete && ((isAdd || isEdit) && !(isShowDtlAddPanel || isShowDtlEditPanel)) && hdrBtns.push({
            id: 'onDeleteButton',
            icon: 'Icon-trash',
            title: 'Delete'
        })

        return hdrBtns
    }, [allowDelete, isAdd, isEdit, isShowDtlAddPanel, isShowDtlEditPanel])

    const memoMovementPatternDtlTable = useMemo(() => {

        return (
            <>
                <TableWrapper>
                    {(allowUpdate) && <RightClickMenuWithMoveAfter disabled={!(isEdit || isAdd) || _.isEmpty(getSelectedRows())}
                        rightClickRef={rightClickRef} selectedRows={getSelectedRows()} allRows={getAllRows()}
                        onSaveMove={onSaveMove} onCancel={onMoveCancel} onRefreshRow={onRefreshRow}
                        showConfirmMove={showMoveCursor} priorityName="seq" />}
                    <div id="myDiv">
                        <NbisTable
                            id='movement-pattern-dtl-table'
                            isNewColumnSetting={true}
                            headerLabel={MovementPatternConstant.Title.DTL_TITLE}
                            columns={INITIAL_MOVEMENT_PATTERN_DTL_COL_DEF}
                            data={allRows ?? []}
                            showPaginator={false}
                            editable={false}
                            headerActionButtons={memoBtns}
                            onDeleteButton={handDelete}
                            showAddIcon={allowCreate && ((isAdd || isEdit) && !(isShowDtlAddPanel || isShowDtlEditPanel))}
                            onAddClick={handleAddClick}
                            showDeleteButton={false}
                            showReloadIcon={false}
                            showUploadIcon={false}
                            isScrollHighlighted={true}
                            selectionMode={false}
                            isRowHighligted={true}
                            handleSelectionChanged={handleSelectionChange}
                            onRowDoubleClick={(e: any, entity: MovementPatternDtlEntity) => handleRowDoubleClick(entity)}
                            gridHeight="customHeight"
                            customHeight="calc(100vh - 90px)"
                            ref={gridRef}
                            rowSelection={showMoveCursor ? "single" : "multiple"}
                            // onBodyScroll={(e: any) => changeCursor("movement-pattern-dtl-table", getShowMoveCursor())}
                            showCutCursor={showMoveCursor}
                        />
                    </div>
                </TableWrapper >
            </>
        );
    }, [allowCreate, allowUpdate, getSelectedRows, rightClickRef, getAllRows, onSaveMove, onMoveCancel, onRefreshRow, showMoveCursor, allRows, memoBtns, handDelete, isAdd, isEdit, isShowDtlAddPanel, isShowDtlEditPanel, handleAddClick, handleSelectionChange, handleRowDoubleClick])

    useEffect(() => {
        if (initialAllRows) {
            if (movementPatternState.tempDtlRows && !_.isEmpty(movementPatternState.tempDtlRows)) {
                setAllRows(movementPatternState.tempDtlRows.map((movementPatternDtlEntity, index) => ({
                    ...movementPatternDtlEntity,
                    index: index || 0
                })));
            } else if (!movementPatternState.tempDtlRows || _.isEmpty(movementPatternState.tempDtlRows)) {
                setAllRows([]);
            }
            setInitialAllRows(false);
        }
    }, [allRows, initialAllRows, movementPatternState.tempDtlRows]);

    useEffect(() => {
        setInitialAllRows(true);
    }, [movementPatternState.dtlForceRefresh]);

    return <>
        <div className={`main-comp-wrapper${(isShowDtlAddPanel || isShowDtlEditPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={(isShowDtlAddPanel || isShowDtlEditPanel) ? "40%" : "100%"}
                rightSectionWidth={(isShowDtlAddPanel || isShowDtlEditPanel) ? "60%" : "0%"}
                leftChildren={memoMovementPatternDtlTable}
                rightChildren={<MovementPatternDtlEditPanel />}
            />
            {movementPatternState.dtlForceRefresh && <></>}
        </div>
    </>
}

export default memo(MovementPatternDtlTablePanel);
